export default {
  primary: {
    lighter: '#ffac35',
    default: '#f18e00',
    darker: '#b46a00',
  },
  secondary: {
    lighter: '#766c61',
    default: '#413b35',
    darker: '#302c27',
  },
  tertiary: {
    lighter: '#766c61',
    default: '#413b35',
    darker: '#302c27',
  },
  positive: {
    default: '#78C091',
  },
  negative: {
    default: '#ea6258',
  },
  grayscale: {
    darker: '#121212',
    default: '#212121',
    lighter: '#535353',
  },
  warning: {
    darker: '#caba04',
    default: '#eab308',
    lighter: '#facc15',
  },
}
